

























import Vue from 'vue'
import { Icon } from '@raksul/kamii-vue'
export default Vue.extend({
  components: {
    Icon
  },
  props: {
    openIcon: {
      type: String,
      default: 'chevronTop'
    },
    closeIcon: {
      type: String,
      default: 'chevronBottom'
    },
    initState: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: this.initState
    }
  }
})
